import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
//components
import AutoCompleteInput from './autoCompleteInput';

const SearchEntity = ({
  fetchData,
  filterField,
  onSelected,
  defaultValue = null,
  placeholder = '',
  labelField = 'label',
  valueField = 'value',
  additionalFields = [],
  showLabel = '',
  isMulti = false,
  formatCustomLabel = false,
}) => {
  const [selectedItem, setSelectedItem] = useState(null);

  useEffect(() => {
    if (defaultValue) {
      // Si el valor de defaultValue no ha cambiado, no actualizamos el estado
      const newSelectedItem = Array.isArray(defaultValue)
        ? defaultValue.map((item) => ({
          label: item[labelField] || item.label,
          value: item[valueField] || item.value,
          ...additionalFields.reduce((acc, field) => {
            acc[field] = item[field];
            return acc;
          }, {}),
        }))
        : [{
          label: defaultValue[labelField] || defaultValue.label,
          value: defaultValue[valueField] || defaultValue.value,
          ...additionalFields.reduce((acc, field) => {
            acc[field] = defaultValue[field];
            return acc;
          }, {}),
        }];

      // Solo actualizar si newSelectedItem es diferente de selectedItem
      if (JSON.stringify(newSelectedItem) !== JSON.stringify(selectedItem)) {
        setSelectedItem(newSelectedItem);
      }
    } else {
      setSelectedItem(null);
    }
  }, [defaultValue, labelField, valueField, additionalFields, selectedItem]);

  const onSearch = async (value) => {
    if (value.length > 1) {
      const { status, data } = await fetchData({
        page: 1,
        page_size: 10,
        search: value,
        fields: `id,${filterField}`,
      });
      if (status === 200) {
        const items = Array.isArray(data.results) ? data.results : data;
        return items.map((item) => ({
          label: item.codigo
            ? `${item.codigo}${item.descripcion ? ` (${item.descripcion})` : ''}`
            : item[labelField],
          value: item[valueField],
          ...additionalFields.reduce((acc, field) => {
            acc[field] = item[field];
            return acc;
          }, {}),
        }));
      }
    }
    return [];
  };

  const formatOptionLabel = ({ label }) => {
    if (formatCustomLabel && label.includes('(')) {
      const title = label.split('(')[0];
      const description = label.split('(')[1]?.replace(')', '') || '';
      return <span><b>{title.trim()}</b> {description && `(${description})`}</span>;
    }
    return <span>{label}</span>;
  };

  return (
    <AutoCompleteInput
      label={showLabel}
      defaultOptions={selectedItem || []}
      defaultValue={selectedItem || []}
      onSelect={onSelected}
      onSearch={onSearch}
      placeholder={placeholder}
      isMulti={isMulti}
      formatOptionLabel={formatOptionLabel}
    />
  );
};

SearchEntity.propTypes = {
  fetchData: PropTypes.func.isRequired,
  filterField: PropTypes.string.isRequired,
  onSelected: PropTypes.func.isRequired,
  defaultValue: PropTypes.oneOfType([PropTypes.array, PropTypes.object]),
  placeholder: PropTypes.string,
  labelField: PropTypes.string,
  valueField: PropTypes.string,
  additionalFields: PropTypes.arrayOf(PropTypes.string),
  showLabel: PropTypes.string,
  isMulti: PropTypes.bool,
};

export default SearchEntity;